import ApiAcces from "@/shared/services/ApiAcces";
import type IAuthService from "../contracts/IAuthService";
import type ForgotPasswordRequest from "../models/ForgotPasswordRequest";
import type ResetPasswordRequest from "../models/ResetPasswordRequest";

export default class AuthService extends ApiAcces implements IAuthService {
  async forgotPassword(request: ForgotPasswordRequest): Promise<void> {
    await this.api.post("/api/auth/forgot-password", request);
  }

  async resetPassword(request: ResetPasswordRequest): Promise<void> {
    await this.api.post("/api/auth/reset-password", request);
  }
}
